export const getHelpData = entity => {
    const result = {
        helpText: '',
        linkData: []
    };

    if (entity) {
        if (entity.help) {
            if (typeof entity.help === 'string') {
                result.helpText = entity.help;
            } else if (typeof entity.help === 'object') {
                result.helpText = entity.help.text;
                result.linkData = entity.help.HyperLinks;
            }
        } else if (entity.HyperLinkedText) {
            result.helpText = entity.HyperLinkedText[0]?.text;
            result.linkData = entity.HyperLinkedText[0]?.HyperLinks;
        }
    }
    return result;
};
